<template>
  <div class="switcher" ref="langRef" v-if="currentLocale">
    <div class="switcher__button" @click="setSwitcherVisible(!isSwitcherVisible)">
      <img class="switcher__button-flag" :src="currentLocale.flag" :alt="currentLocale.code">
    </div>
    <div class="switcher__menu" :class="[{active: isSwitcherVisible}]">
      <img
        class="switcher__menu-button"
        v-for="locale of locales"
        :key="locale.code"
        @click="switchLocale(locale.code)"
        :src="locale.flag"
        :alt="locale.code"
      />
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import translations from "@/core/helpers/translations.js";
import {useRoute, useRouter} from "vue-router";
import { onClickOutside } from '@vueuse/core'
import {Languages} from "@/core/api/languages.js";
import translation from "@/core/helpers/translations.js";

const route = useRoute()
const router = useRouter()

const locales = ref([])

const isSwitcherVisible = ref(false)
const setSwitcherVisible = (state) => {
  isSwitcherVisible.value = state
}

const langRef = ref(null)
onClickOutside(langRef, () => isSwitcherVisible.value = false)

const currentLocale = ref(null)

const getLanguages = async () => {
  const res = await Languages.getLanguages()
  locales.value = res.data.languages.filter((locale) => translation.supportedLocales.includes(locale.code));
  currentLocale.value = locales.value.find((locale) => locale.code === translation.currentLocale)
}

const switchLocale = async (newLocale) => {
  // if (userUuid.value && accessToken.value) {
  //   const res = await Auth.setLanguage(userUuid.value, accessToken.value, newLocale)
  //
  //   if (!res.errors) {
  //     authStore.setUser({
  //       user: res.data.updateUser.user,
  //       accessToken: accessToken.value
  //     })
  //
  //     if (newLocale !== translation.currentLocale) {
  //       translations.switchLanguage(newLocale)
  //     }
  //
  //     setSwitcherVisible(false)
  //
  //     await router.push({
  //       name: route.name,
  //       params: {
  //         ...route.params,
  //         locale: newLocale
  //       },
  //       query: { ...route.query }
  //     })
  //   }
  // } else {
    setSwitcherVisible(false)
    translations.switchLanguage(newLocale)

      await router.push({
        name: route.name,
        params: {
          ...route.params,
          locale: newLocale
        },
        query: { ...route.query }
      })
  // }
}

watch (
  () => translation.currentLocale,
  () => {
    currentLocale.value = locales.value.find((locale) => locale.code === localStorage.getItem('gce-user-locale'))
  }
)

onMounted(async () => {
  await getLanguages()
})
</script>

<style lang="scss" scoped>
.switcher {
  position: relative;
  z-index: 3;

  &__button {
    cursor: pointer;
    display: flex;
    gap: 5px;

    &-flag {
      transition: 0.2s;
      width: 35px;
      padding: 5px 10px;
      box-sizing: content-box;
    }
  }

  &__menu {
    position: absolute;
    z-index: 3;
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #22222d;
    display: flex;
    flex-direction: column;
    max-height: 0;
    overflow: hidden;
    border-radius: 0 0 10px 10px;
    transition: max-height 0.3s ease;

    &.active {
      max-height: 1000px;
    }

    &-button {
      width: 35px;
      cursor: pointer;
      padding: 5px 10px;
      background-color: #bfd2c9;
      box-sizing: content-box;

      &:first-child {
        padding-top: 10px;
      }
      &:last-child {
        padding-bottom: 10px;
      }

      @include hover {
        background-color: $main;
      }
    }
  }
}
</style>